import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import TopCardP from "../ui/compoP/TopCardP";
import TopCardStaticP from "../ui/compoP/TopCardStaticP";
import LogoP from "../ui/atoms/LogoP";
import TopAccess from "../ui/compoC/TopAccessP";
import TopSns from "../ui/compoC/TopSnsP";
import CopyLangP from "../ui/compoC/CopyLangP";
import AllPopups from "../ui/compoP/AllPopups";
import Avatar from "../ui/compoP/AvatarP";
import pb from "../services/pocketbase";
import {
  currentUser,
  ensureAuthHydrated,
  getFileUrl,
  isAuthenticated,
} from "../auth/authApi";
import "../styles/main.scss";
import "../styles/compo.scss";
import "../styles/vars.scss";

const Top = () => {
  const [activePopupId, setActivePopupId] = useState(null);
  const [isTopLayout3, setIsTopLayout3] = useState(false);
  const navigate = useNavigate();

  const handleClosePopup = () => setActivePopupId(null);

  const [userData, setUserData] = useState(null);
  const hasToken = Boolean(localStorage.getItem("token"));

  const displayName = useMemo(() => {
    if (!userData) return "";
    return (
      (userData.fullName && String(userData.fullName).trim()) ||
      (userData.username && String(userData.username).trim()) ||
      (userData.email && String(userData.email).split("@")[0]) ||
      ""
    );
  }, [userData]);

  const topDisplayNameNode = useMemo(() => {
    const n = String(displayName || "").trim();
    if (!n) return "";
    const firstSpace = n.indexOf(" ");
    if (firstSpace === -1) return n;
    return (
      <>
        {n.slice(0, firstSpace)}
        <br />
        {n.slice(firstSpace + 1)}
      </>
    );
  }, [displayName]);

  const avatarUrl = useMemo(() => {
    if (!userData) return undefined;
    const url = getFileUrl(userData, userData?.avatar);
    return url || undefined;
  }, [userData]);

  useEffect(() => {
    const sync = () => {
      const u = currentUser();
      if (isAuthenticated() && u) setUserData(u);
      else setUserData(null);
    };
    sync();

    if (hasToken) {
      ensureAuthHydrated()
        .then((u) => {
          if (u) setUserData(u);
        })
        .catch(() => {});
    }

    const unsub = pb.authStore.onChange(() => sync(), true);
    return () => unsub();
  }, [hasToken]);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 1100px) and (min-width: 801px)");
    const updateLayout = () => setIsTopLayout3(mediaQuery.matches);
    updateLayout();

    mediaQuery.addEventListener("change", updateLayout);
    return () => mediaQuery.removeEventListener("change", updateLayout);
  }, []);

  const topUserNode = (() => {
    // keep the empty space when logged out
    if ((!isAuthenticated() && !hasToken) || !userData) {
      return <div className="top-user-card-spacer" />;
    }

    return (
      <div
        className="top-user-pill"
        role="button"
        tabIndex={0}
        onClick={() => {
          const slug =
            (userData.username && String(userData.username).trim()) ||
            (userData.email && String(userData.email).split("@")[0]) ||
            "";
          if (!slug) return;
          navigate(`/${encodeURIComponent(slug)}`);
        }}
      >
        <Avatar imageUrl={avatarUrl} size={72} className="top-user-avatar" />
        <div className="top-user-text">
          <div className="top-user-name">{topDisplayNameNode}</div>
        </div>
      </div>
    );
  })();

  const cardData = [
    {
      component: TopCardStaticP,
      props: {
        className: "static",
        children: (
          <LogoP
            logo="logo01"
            hoverLogo="logo03"
            logoTypeEn="logotype_en"
            logoTypeJp="logotype_jp"
            style={{ width: "80px" }}
          />
        ),
      },
    },
    {
      component: TopCardP,
      props: {
        icon: "tool",
        title: "TOOLS",
        text: "Tools & Apps",
        clickable: true,
        color: "tools",
        onClick: () => navigate("/tools"),
      },
    },
    {
      component: TopCardP,
      props: {
        icon: "idea",
        title: "IDEAZ",
        text: "Inspiration",
        clickable: true,
        color: "ideaz",
        onClick: () => navigate("/ideaz"),
      },
    },
    {
      component: TopCardP,
      props: {
        icon: "resos",
        title: "RESOS",
        text: "Resources & Materials",
        clickable: true,
        color: "resos",
        onClick: () => navigate("/resos"),
      },
    },
    // {
    //   component: TopCardStaticP,
    //   props: {
    //     icon: "talx",
    //     title: "TALX",
    //     text: "COMING SOON",
    //     to: "/home",
    //     clickable: false,
    //     // color: "talx",
    //   },
    // },

        
    {
      component: TopCardStaticP,
      props: {
        children: topUserNode,
        className: "top-user-cell",
        clickable: false,
        title: "",
      },
    },
    
    {
      component: TopCardStaticP,
      props: {
        children: <TopAccess />,
      },
    },
    {
      component: TopCardP,
      props: {
        icon: "apps",
        title: "APPS",
        text: "Mobile Apps",
        clickable: true,
        color: "honey",
        onClick: () => navigate("/apps"),
      },
    },

    { component: TopCardP },
    {
      component: TopCardStaticP,
      props: {
        icon: "talx",
        title: "TALX",
        text: "COMING SOON",
        to: "/home",
        clickable: false,
        // color: "talx",
      },
    },

    // { component: TopCardP },

    {
      component: TopCardStaticP,
      props: {
        icon: "uxers",
        title: "UXERS",
        text: "COMING SOON",
        to: "/home",
        clickable: false,
      },
    },

    // {
    //   component: TopCardP,
    //   props: {
    //     icon: "game_b",
    //     title: "DESIGN BATTLE",
    //     text: "UXUI Games",
    //     to: "/",
    //     color: "dark",
    //     clickable: true,
    //     onClick: () => navigate("/db/"),
    //   },
    // },

    {
      component: TopCardP,
      props: {
        icon: "service_b",
        title: "UUD TOOLS",
        text: "Original Tools",
        clickable: true,
        color: "uudtools",
        onClick: () => navigate("/uudtools"),
      },
    },
    {
      component: TopCardP,
      props: {
        icon: "uud1",
        title: "ABOUT US",
        clickable: true,
        color: "pri",
        className: "small",
        onClick: () => setActivePopupId("about"),
      },
    },
    {
      component: TopCardP,
      props: {
        icon: "mail",
        title: "CONTACT",
        to: "/home",
        clickable: true,
        color: "pri",
        className: "small",
        onClick: () => setActivePopupId("contact"),
      },
    },
    {
      component: TopCardStaticP,
      props: {
        icon: "event",
        title: "EVENTS",
        text: "COMING SOON",
        to: "/home",
        clickable: false,
      },
    },
    {
      component: TopCardStaticP,
      props: {
        children: <TopSns />,
      },
    },
    ...(isTopLayout3 ? [{ component: TopCardP }] : []),
    {
      component: TopCardStaticP,
      props: {
        children: <CopyLangP />,
      },
    },
  ];

  return (
    <div className="top-page-container">
      <div className="top-grid">
        {cardData.map((card, index) => {
          const Component = card.component;
          return <Component key={index} {...card.props} />;
        })}
      </div>
      <AllPopups activePopupId={activePopupId} onClose={handleClosePopup} />
    </div>
  );
};

export default Top;
